module.exports = __webpack_public_path__ + "img/marketplace_content_creators.283ae915.svg";